import React, {Component} from 'react';
import './TutorialContent.css';

export default class TutorialContent extends Component
{

  constructor(props)
  {
  super(props);
  this.state=
  {
    TutorialSections:this.props.TutorialSections,
    isLoading: true,
    error: null
  }

  }

  async componentDidMount()
  {

    try 
    {
      this.state=
      {
        TutorialSections:this.props.TutorialSections,
        isLoading: false
      }

    }catch(error)
    {
      console.error("Error while fetching the tutorial content:",error);
    }
    
  }

  render()
  {
     let tutorialSections= this.state.TutorialSections;
    return (
<main className="tutorial-content">
      {tutorialSections && tutorialSections !== null && tutorialSections !== undefined &&
        tutorialSections.map((item, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: item.Section }} />
        ))
      }
      {/* <div className="tutorial-image-box" style={{
        margin: "2rem auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        background: "#f3f9fb",
        borderRadius: "1rem",
        boxShadow: "0 1px 8px rgba(0,0,0,0.09)",
        padding: "1.5rem",
        maxWidth: "480px"
      }}>
        <img
          src={this.props.imageUrl || "https://localhost:7029/images/tutorial/microservices/microserivces-architecture.png"}
          alt={this.props.imageAlt || "Tutorial Visual"}
          style={{
            width: "100%",
            maxWidth: "400px",
            borderRadius: "0.7rem",
            marginBottom: "1rem",
            objectFit: "cover",
            boxShadow: "0 2px 12px rgba(0,0,0,0.07)"
          }}
        />
        {this.props.imageCaption &&
          <div style={{
            color: "#4fd1c5",
            fontSize: "1rem",
            marginTop: "0.5rem",
            textAlign: "center"
          }}>
            {this.props.imageCaption}
          </div>
        }
      </div> */}
  </main>
    )

  }
}
